/* SDreamz YMM vehicle selector — $0/mo DIY fitment (see CLAUDE.md "Fitment").
 *
 * HOW IT WORKS: bolt pattern + hub bore never change with lifts/mods, so the
 * selector resolves the vehicle's BOLT PATTERN and deep-links into the matching
 * smart collection (/collections/<bolt>-wheels), where native S&D filters let
 * the customer dial diameter/offset to their (possibly lifted) setup.
 *
 * DATA: curated per-generation table below — REVIEWED BY JUJU (wheel-fitment
 * domain expert) before trusting. Bolt strings must match the canonical
 * fitment.bolt_pattern metafield values (metric, e.g. "6x139.7").
 * Suspension link is interim (/search) until RC fitment metafields land.
 */
window.SD_VEHICLES = [
  // make, model, yearStart, yearEnd, bolt, rcPartsHandle ("" = no suspension link)
  // TRUCKS & SUVs — tech-reviewed 2026-07-25 (Truck Fitment Guide.xlsx)
  ["Ford", "F-150", 2004, 2026, "6x135", "ford-f-150-parts"],
  ["Ford", "F-150", 1997, 2003, "5x135", "ford-f-150-parts"],
  ["Ford", "F-250 Super Duty", 1999, 2026, "8x170", "ford-f-250-parts"],
  ["Ford", "F-350 Super Duty SRW", 1999, 2026, "8x170", "ford-f-350-parts"],
  ["Ford", "F-350 Dually", 2005, 2026, "8x200", "ford-f-350-parts"],
  ["Ford", "F-450 Dually", 2015, 2026, "10x225", ""],
  ["Ford", "F-450 Dually", 2011, 2014, "8x200", ""],
  ["Ford", "Ranger", 2019, 2026, "6x139.7", "ford-ranger-parts"],
  ["Ford", "Ranger", 1998, 2011, "5x114.3", "ford-ranger-parts"],
  ["Ford", "Bronco", 2021, 2026, "6x139.7", "ford-bronco-parts"],
  ["Ford", "Expedition", 2003, 2026, "6x135", "ford-expedition-parts"],
  ["Ford", "Excursion", 2000, 2005, "8x170", "ford-excursion-parts"],
  ["Chevrolet", "Silverado 1500", 1999, 2026, "6x139.7", "chevrolet-silverado-1500-parts"],
  ["Chevrolet", "Silverado 2500HD", 2011, 2026, "8x180", "chevrolet-silverado-2500hd-parts"],
  ["Chevrolet", "Silverado 2500HD", 2001, 2010, "8x165.1", "chevrolet-silverado-2500hd-parts"],
  ["Chevrolet", "Silverado 3500HD SRW", 2011, 2026, "8x180", "chevrolet-silverado-3500hd-parts"],
  ["Chevrolet", "Silverado 3500HD", 2001, 2010, "8x165.1", "chevrolet-silverado-3500hd-parts"],
  ["Chevrolet", "Silverado 3500HD Dually", 2011, 2026, "8x210", "chevrolet-silverado-3500hd-parts"],
  ["Chevrolet", "Silverado 3500HD Dually", 1977, 2010, "8x165.1", "chevrolet-silverado-3500hd-parts"],
  ["Chevrolet", "Colorado", 2023, 2026, "6x139.7", "chevrolet-colorado-parts"],
  ["Chevrolet", "Colorado", 2015, 2022, "6x120", "chevrolet-colorado-parts"],
  ["Chevrolet", "Colorado", 2004, 2012, "6x139.7", "chevrolet-colorado-parts"],
  ["Chevrolet", "Tahoe", 1995, 2026, "6x139.7", "chevrolet-tahoe-parts"],
  ["Chevrolet", "Suburban", 1995, 2026, "6x139.7", "chevrolet-suburban-parts"],
  ["Chevrolet", "Avalanche", 2002, 2013, "6x139.7", "chevrolet-avalanche-parts"],
  ["GMC", "Sierra 1500", 1999, 2026, "6x139.7", "gmc-sierra-1500-parts"],
  ["GMC", "Sierra 2500HD", 2011, 2026, "8x180", "gmc-sierra-2500hd-parts"],
  ["GMC", "Sierra 2500HD", 2001, 2010, "8x165.1", "gmc-sierra-2500hd-parts"],
  ["GMC", "Sierra 3500HD SRW", 2011, 2026, "8x180", "gmc-sierra-3500hd-parts"],
  ["GMC", "Sierra 3500HD Dually", 2011, 2026, "8x210", "gmc-sierra-3500hd-parts"],
  ["GMC", "Sierra 3500HD Dually", 1977, 2010, "8x165.1", "gmc-sierra-3500hd-parts"],
  ["GMC", "Canyon", 2023, 2026, "6x139.7", "gmc-canyon-parts"],
  ["GMC", "Canyon", 2015, 2022, "6x120", "gmc-canyon-parts"],
  ["GMC", "Canyon", 2004, 2012, "6x139.7", "gmc-canyon-parts"],
  ["GMC", "Yukon", 1995, 2026, "6x139.7", "gmc-yukon-parts"],
  ["Ram", "1500", 2019, 2026, "6x139.7", "ram-1500-parts"],
  ["Ram", "1500 Classic", 2002, 2023, "5x139.7", "ram-1500-classic-parts"],
  ["Ram", "2500", 1994, 2026, "8x165.1", "ram-2500-parts"],
  ["Ram", "3500 (SRW)", 1994, 2026, "8x165.1", "ram-3500-parts"],
  ["Ram", "3500 Dually", 2019, 2026, "8x200", "ram-3500-parts"],
  ["Toyota", "Tacoma", 1995, 2026, "6x139.7", "toyota-tacoma-parts"],
  ["Toyota", "Tundra", 2022, 2026, "6x139.7", "toyota-tundra-parts"],
  ["Toyota", "Tundra", 2007, 2021, "5x150", "toyota-tundra-parts"],
  ["Toyota", "Tundra", 2000, 2006, "6x139.7", "toyota-tundra-parts"],
  ["Toyota", "4Runner", 1996, 2026, "6x139.7", "toyota-4runner-parts"],
  ["Toyota", "Sequoia", 2023, 2026, "6x139.7", "toyota-sequoia-parts"],
  ["Toyota", "Sequoia", 2008, 2022, "5x150", "toyota-sequoia-parts"],
  ["Toyota", "Sequoia", 2001, 2007, "6x139.7", "toyota-sequoia-parts"],
  ["Toyota", "Land Cruiser", 2024, 2026, "6x139.7", "toyota-land-cruiser-parts"],
  ["Toyota", "Land Cruiser", 1998, 2021, "5x150", "toyota-land-cruiser-parts"],
  ["Jeep", "Wrangler (JK/JL)", 2007, 2026, "5x127", "jeep-wrangler-parts"],
  ["Jeep", "Wrangler (TJ)", 1997, 2006, "5x114.3", "jeep-wrangler-tj-parts"],
  ["Jeep", "Gladiator", 2020, 2026, "5x127", "jeep-gladiator-parts"],
  ["Jeep", "Grand Cherokee", 1999, 2026, "5x127", "jeep-grand-cherokee-parts"],
  ["Nissan", "Titan", 2004, 2026, "6x139.7", "nissan-titan-parts"],
  ["Nissan", "Titan XD", 2016, 2024, "6x139.7", "nissan-titan-parts"],
  ["Nissan", "Frontier", 2005, 2026, "6x114.3", "nissan-frontier-parts"],
  // CARS — added 2026-07-25, PENDING TECH REVIEW (no suspension link)
  ["Ford", "Mustang", 1994, 2026, "5x114.3", ""],
  ["Chevrolet", "Camaro", 2010, 2024, "5x120", ""],
  ["Chevrolet", "Corvette", 1984, 2026, "5x120.65", ""],
  ["Dodge", "Charger", 2006, 2023, "5x115", ""],
  ["Dodge", "Challenger", 2008, 2023, "5x115", ""],
  ["Chrysler", "300", 2005, 2023, "5x115", ""],
  ["Honda", "Civic", 2006, 2026, "5x114.3", ""],
  ["Honda", "Accord", 2003, 2026, "5x114.3", ""],
  ["Toyota", "Camry", 1992, 2026, "5x114.3", ""],
  ["Toyota", "Corolla", 2019, 2026, "5x114.3", ""],
  ["Toyota", "Corolla", 2003, 2018, "5x100", ""],
  ["Toyota", "Supra", 2020, 2026, "5x112", ""],
  ["Nissan", "Altima", 2002, 2026, "5x114.3", ""],
  ["Nissan", "Maxima", 2000, 2023, "5x114.3", ""],
  ["Nissan", "350Z / 370Z / Z", 2003, 2026, "5x114.3", ""],
  ["BMW", "3 Series", 2019, 2026, "5x112", ""],
  ["BMW", "3 Series", 1999, 2018, "5x120", ""],
  ["Mercedes-Benz", "C-Class", 1994, 2026, "5x112", ""],
  ["Mercedes-Benz", "E-Class", 1996, 2026, "5x112", ""],
  ["Audi", "A4 / A5", 1996, 2026, "5x112", ""],
  ["Volkswagen", "Golf / Jetta", 2006, 2026, "5x112", ""],
  ["Tesla", "Model 3 / Y", 2017, 2026, "5x114.3", ""],
  ["Tesla", "Model S / X", 2012, 2026, "5x120", ""],
  ["Lexus", "IS / ES", 1999, 2026, "5x114.3", ""],
  ["Infiniti", "G / Q", 2003, 2026, "5x114.3", ""],
  ["Subaru", "WRX", 2015, 2026, "5x114.3", ""],
  ["Subaru", "WRX", 2002, 2014, "5x100", ""],
  ["Kia", "Optima / K5", 2011, 2026, "5x114.3", ""],
  ["Hyundai", "Sonata", 2011, 2026, "5x114.3", ""],
];

(function () {
  var KEY = "sd_ymm_truck";
  var V = window.SD_VEHICLES;

  function boltHandle(bolt) {
    return "/collections/" + bolt.replace(".", "-") + "-wheels";
  }
  function liftLink(row) {
    return "/collections/" + row[5];
  }
  function opts(sel, values, ph) {
    sel.innerHTML = "";
    var o = document.createElement("option");
    o.value = ""; o.textContent = ph; sel.appendChild(o);
    values.forEach(function (v) {
      var e = document.createElement("option");
      e.value = v; e.textContent = v; sel.appendChild(e);
    });
  }
  function uniq(a) { return Array.from(new Set(a)); }

  function init(root) {
    var yearS = root.querySelector("[data-ymm-year]");
    var makeS = root.querySelector("[data-ymm-make]");
    var modelS = root.querySelector("[data-ymm-model]");
    var out = root.querySelector("[data-ymm-result]");

    var years = [];
    for (var y = 2026; y >= 1994; y--) years.push(String(y));
    opts(yearS, years, "Year");
    opts(makeS, [], "Make");
    opts(modelS, [], "Model");
    makeS.disabled = modelS.disabled = true;

    function rowsFor(year, make) {
      return V.filter(function (r) {
        return (!year || (r[2] <= year && year <= r[3])) && (!make || r[0] === make);
      });
    }
    yearS.addEventListener("change", function () {
      var y = +yearS.value;
      opts(makeS, uniq(rowsFor(y).map(function (r) { return r[0]; })).sort(), "Make");
      makeS.disabled = !y;
      opts(modelS, [], "Model"); modelS.disabled = true;
      out.innerHTML = "";
    });
    makeS.addEventListener("change", function () {
      var y = +yearS.value;
      opts(modelS, uniq(rowsFor(y, makeS.value).map(function (r) { return r[1]; })).sort(), "Model");
      modelS.disabled = !makeS.value;
      out.innerHTML = "";
    });
    modelS.addEventListener("change", function () {
      render(+yearS.value, makeS.value, modelS.value);
    });

    function render(year, make, model) {
      var row = V.find(function (r) {
        return r[0] === make && r[1] === model && r[2] <= year && year <= r[3];
      });
      if (!row) { out.innerHTML = ""; return; }
      try { localStorage.setItem(KEY, JSON.stringify({ y: year, m: make, o: model })); } catch (e) {}
      var bolt = row[4];
      out.innerHTML =
        '<p class="sd-ymm__fit">' + year + " " + make + " " + model +
        ' — bolt pattern <strong>' + bolt + "</strong></p>" +
        '<div class="sd-ymm__actions">' +
        '<a class="button" href="' + boltHandle(bolt) + '">Shop wheels that fit</a>' +
        (row[5] ? '<a class="button button--secondary" href="' + liftLink(row) + '">Lift kits &amp; suspension</a>' : "") +
        "</div>" +
        (row[5]
          ? '<p class="sd-ymm__note">All diameters &amp; offsets shown — running a lift? Use the offset and diameter filters to match your setup.</p>'
          : '<p class="sd-ymm__note">All diameters &amp; offsets shown — use the filters to dial in your fitment.</p>');
    }

    // restore saved truck
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || "null");
      if (saved && saved.y) {
        yearS.value = String(saved.y);
        yearS.dispatchEvent(new Event("change"));
        makeS.value = saved.m;
        makeS.dispatchEvent(new Event("change"));
        modelS.value = saved.o;
        render(saved.y, saved.m, saved.o);
      }
    } catch (e) {}
  }

  document.querySelectorAll("[data-sd-ymm]").forEach(init);
})();
